module.exports = __webpack_public_path__ + "img/zf_icon01-6eecec.png";